import React, { useEffect } from "react";
import { Form, Input, Select, Space } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getClientDetails, 
	doClientCreate, 
	doClientUpdate 
} from "../../../../redux/client/clientState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import SelectWithOthers from "components/fields/SelectWithOthers";
import { getLabel } from "utils";
import { MODULE_CLIENT } from "variables/constants";
import SectionHeader from "components/section/SectionHeader";

const ClientForm = ({ 
	getRecord, 
	doCreate, 
	doUpdate, 
	onCancel, 
	recordData, 
	requesting, 
	submitLabel,
	isModal=true,
	...props
}) => {

	const { TextArea } = Input;
  	const { recordId, mode } = props;
	const [form] = useForm();
	const LOB_OTHERS = 65;

	const lobId = Form.useWatch("clt_lob_id", form);
	
  	useEffect(() => {
		if(recordId){
		  getRecord(recordId);
		}
	  }, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { client:clt_name, clt_account_id, address, billing_info,  ...rest } = recordData;

			const initialValues = {
				...rest,
				...address,
				clt_account_id: recordData?.clt_account_id ?? "",
				clt_name: recordData?.clt_name ?? "",
				clt_lob_id: recordData?.clt_lob_id ?? "",
				clt_lob_name: recordData?.clt_lob_name ?? "",
				...Object.fromEntries(
					Object.entries(billing_info || {}).map(([key, value]) => [`billing_${key}`, value])
				),	
			};	

	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {
    	try { 
			recordData?.clt_id > 0 ? doUpdate(formData): doCreate(formData);
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
		<Form className={mode !== "view" ? "form" : ""}
			layout="vertical"
			form={form} 
			onFinish={onSubmit}
		>   
			<FormItem
				name="clt_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">		
				<FormItem
					name="clt_name"
					label="Client Name"
					rules={[requiredField]}
				>
					{mode !== "view" ?
						<Input id="clt_name"
							className="input-field"
							maxLength={100}
						/>
						:
						<label className="text-base label-value dark:text-white">
							{recordData?.clt_name}
						</label>
					}
				</FormItem>    		            	            
				<FormItem
					name="clt_entity_name"
					label="Entity Name"
					rules={[requiredField]}
				>
					
					{mode !== "view" ? 
						<Input id="clt_entity_name"
							className="input-field"
							maxLength={100}
						/>
						:
						<label className="text-base label-value dark:text-white">
							{recordData?.clt_entity_name}
						</label>
					}
				</FormItem>
				<FormItem
					label="Client Status"
					name="clt_status_id"
					rules={[requiredField()]}
				>
					{mode !== "view" ?
					<Select id="clt_status_id"
						className="input-field"
						showSearch
						allowClear={true}
						options={recordData?.clientStatusList}
					/>
					: 
					<label className="text-base label-value dark:text-white">
						{getLabel(recordData?.clientStatusList, recordData?.clt_status_id)}
					</label>
					}
				</FormItem>	  
			</div>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
				<div className={
						mode !== "view" && lobId === LOB_OTHERS
							? "col-span-2" 
							: "col-span-1" 
					}
				>
					<FormItem
						name="clt_lob_id"
						label="Line Of Business"
					>
						{mode !== "view" ? (
						<SelectWithOthers 
							selectFieldName="clt_lob_id"
							selectOptions={recordData?.lineOfBusinessList}
							selectDisplayValue={
							recordData?.clt_lob_id === LOB_OTHERS 
								? recordData?.clt_lob_name 
								: getLabel(recordData?.lineOfBusinessList, recordData?.clt_lob_id)
							}
							othersFieldName="clt_lob_name"
							othersDisplayValue={recordData?.clt_lob_name}
							optionOthersId={[LOB_OTHERS]} 
							othersPlaceholder="Please specify Line of Business"
							mode={mode}
						/>
						) : (
							<label className="text-base label-value dark:text-white">
								{recordData?.clt_lob_id === LOB_OTHERS
									? recordData?.clt_lob_name
									: getLabel(recordData?.lineOfBusinessList, recordData?.clt_lob_id)}
							</label>
						)}
					</FormItem>
				</div>
				<FormItem
					name="clt_website_url"
					label="Website"
				>
					{mode !== "view" ?
						<Input id="clt_website_url"
							className="input-field"
							maxLength={100}
							placeholder="example@email.com"
						/>
						: 	
						<label className="text-base label-value dark:text-white">
							{recordData?.clt_website_url}
						</label>
					}
				</FormItem>
			</div>
			<div className="w-full">
				<FormItem
					name="clt_company_info"
					label="Company Information"
				>
					{mode !== "view" ?
						<TextArea id="clt_company_info"
							className="input-field"
							rows={2}
							maxLength={255}		            		
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.clt_company_info}
						</label>
					}
				</FormItem>
			</div>
			{mode !== "view" ? (
				<>
					<div className="w-full">
						<FormItem
							label="Address Line 1"
							name="add_address_line1"
						>
							<Input type="text"
							className="input-field"
							id="add_address_line1"
							maxLength={100}
							/>
						</FormItem>
					</div>
					<div className="w-full">
						<FormItem
							label="Address Line 2"
							name="add_address_line2"
						>
							<Input type="text"
							className="input-field"
							id="add_address_line2"
							maxLength={100}
							/>
						</FormItem>	
					</div>
					<div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
						<FormItem
							label="City"
							name="add_city"
						>
							<Input type="text"
							className="input-field"
							id="add_city"
							maxLength={50}
							/>
						</FormItem>

						<FormItem
							label="Postal Code"
							name="add_postal_code"
						>
							<Input type="text"
							className="input-field"
							id="add_postal_code"
							maxLength={50}
							/>
						</FormItem>

						<FormItem
							label="Country"
							name="add_country_id"
						>
							<Select id="add_country_id"
								className="input-field"
								showSearch
								allowClear={true}
								options={recordData?.countryList}
							/>
						</FormItem>
					</div>
				</>
			) : (
				<div className="w-full">
					<FormItem label="Address">
						<label className="text-base label-value dark:text-white">
								{(() => {
								if (!recordData?.address) return "-";

								const parts = [
									recordData?.address?.add_address_line1,
									recordData?.address?.add_address_line2,
									recordData?.address?.add_city,
									recordData?.address?.add_postal_code,
									getLabel(recordData?.countryList, recordData?.address?.add_country_id),
								].filter(Boolean);

								return parts.length > 0 ? parts.join(", ") : "-";
							})()}
						</label>
					</FormItem>
				</div>
			)}

			<SectionHeader title="Billing Contact" extra="mt-4"/>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
				<FormItem className="font-medium mb-2"
					name="billing_contact_name"
					label="Contact Person's Name"
					dependencies={['billing_cde_first_name', 'billing_cde_last_name']}
				>
					{mode === 'edit' ?
					<Space.Compact>
						<FormItem 
							name="billing_cde_first_name"
							noStyle				                
						>
							<Input id="billing_cde_first_name"
								placeholder="First Name"
								className="input-field"
								maxLength={50}
							/>
						</FormItem>
						<FormItem 
							name="billing_cde_last_name"				            	
							noStyle 
						>
							<Input id="billing_cde_last_name"
								placeholder="Last Name"
								className="input-field"
								maxLength={50}
							/>
						</FormItem>
					</Space.Compact>
					: <label className="ps-3 dark:text-white">{recordData?.billing_info.contact_full_name}</label>
					}	                
				</FormItem>
				<FormItem 
					name="billing_cde_email"
					label="Billing Email"
				>
					
					{mode !== "view" ? 
						<Input id="billing_cde_email"
							className="input-field"
							maxLength={50}
						/>
						:
						<label className="text-base label-value dark:text-white">
							{recordData?.billing_info.cde_email}
						</label>
					}
				</FormItem>
			</div>

			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.clt_id ?? 0}
						isModal={true}
						modalId={recordData?.clt_id > 0 ? 'edit_client' : 'add_client'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel={submitLabel}
						moduleId={MODULE_CLIENT}
					/>
				)}
			</div>
		</Form>	 
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.client.clientDetails?.data,
	requesting: state.client.clientDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getClientDetails(id)),
  	doCreate: (data) => dispatch(doClientCreate(data)),
  	doUpdate: (data) => dispatch(doClientUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientForm);
